import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { googleOAuthReady } from "@/lib/google-oauth.mjs";
import { connectDemo, getToken, getGoogleConfig, startGoogleAuth } from "@/lib/api";

// Sign-in and demo entry points shared by the site header and the homepage.
export default function useSiteAuth() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);

  const handleConnect = async () => {
    if (getToken()) { navigate("/dashboard"); return; }
    setLoading(true);
    try {
      const cfg = await getGoogleConfig();
      if (googleOAuthReady(cfg, "login") && cfg.auth_mode === "supabase") {
        await startGoogleAuth(cfg);  // redirects away
        return;
      }
      toast.info("Google connection is not available yet. You can explore the demo or sign up with email.");
      setLoading(false);
    } catch (e) {
      toast.error("Couldn't connect. Please try again.");
      setLoading(false);
    }
  };

  const handleDemo = async () => {
    setDemoLoading(true);
    try {
      await connectDemo();
      toast.success("Loading the demo with sample data");
      navigate("/dashboard");
    } catch (e) {
      toast.error("Couldn't load the demo. Please try again.");
      setDemoLoading(false);
    }
  };

  return { loading, setLoading, demoLoading, handleConnect, handleDemo };
}
